import { render, staticRenderFns } from "./AddressSettings.vue?vue&type=template&id=316405ae&scoped=true"
import script from "./AddressSettings.vue?vue&type=script&lang=js"
export * from "./AddressSettings.vue?vue&type=script&lang=js"
import style0 from "./AddressSettings.vue?vue&type=style&index=0&id=316405ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316405ae",
  null
  
)

export default component.exports